<script>
    import { getBaseUrl } from "../utils";
    // import  clientService from "../services/clients.js";

    export default {
        name: "sidebar",
        data() {
            return {
                client: null,
                showCalculations: false // Controla a visibilidade dos <li> filhos
            };
        },
        methods: {
            goTo(option) {
                let url = getBaseUrl();
                switch (option) {
                    case "cts":
                        url = `${url}/contagem/?codigo=${this.client.id}`;
                        break;
                    case "qualidade":
                        url = `${url}/qualidadesegurado/?codigo=${this.client.id}`;
                        break;
                    case "rmi":
                        url = `${url}/rmi/?codigo=${this.client.id}`;
                        break;
                    case "planejamento":
                        url = `${url}/rmi/?codigo=${this.client.id}&planejamento=true`;
                        break;
                    case "evolucao":
                        url = `${url}/evolucao/?codigo=${this.client.id}&type=evolucao`;
                        break;
                    case "inicial":
                        url = `${url}/evolucao/?codigo=${this.client.id}&type=inicial`;
                        break;
                    case "liquidacao":
                        url = `${url}/evolucao/?codigo=${this.client.id}&type=liquidacao`;
                        break;
                    case "rmc":
                        url = `${url}/rmc/?codigo=${this.client.id}`;
                        break;
                    case "revisao":
                        url = `${url}/revisao/?codigo=${this.client.id}`;
                        break;
                }
                    window.open(url, "_blank");
            },
            toggleCalculations() {
                this.showCalculations = !this.showCalculations; // Alterna a visibilidade
            }
        },

        created: function() {
            this.$bus.$on("showClient", data => {
                (this.client = data),
                this.$store.commit("CLIENTS_SET_SELECTED", { client: this.client });
            });
        },
        computed : {
            
        }
    };
</script>
<template>
    <div class="p-sidebar" slot="sidebar">
        <div class="sidebar">
        <aside class="content">
            <nav class="p-nav">
                <ul class="list">
                    <li class="item">
                    <a href="/" class="active p-nav-item">
                        <!-- <svg class="p-icon icon svg-icon svg-fill"><use xlink:href="#sprite-panel"/></svg> -->
                        <i class="fas fa-home icon"></i>
                        <span class="name">Painel</span>
                    </a>
                    </li>
                    <li class="item">
                    <a href="/editar-usuario.php" class="item p-nav-item">
                        <!-- <svg class="p-icon icon svg-icon svg-fill"><use xlink:href="#sprite-user"/></svg> -->
                        <i class="far fa-id-card icon"></i>
                        <span class="name">Meu Perfil</span>
                    </a>
                    </li>
                    <li class="item">
                    <a href="/" class="item p-nav-item">
                        <!-- <svg class="p-icon icon svg-icon svg-fill"><use xlink:href="#sprite-user"/></svg> -->
                        <i class="far fa-list-alt icon"></i>
                        <span class="name">Clientes</span>
                    </a>
                    </li>
                    <li class="item" v-if="false">
                        <a href="/previdia.php" class="item p-nav-item ai-button">
                            <span class="icon">
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sparkles" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path fill="currentColor" d="M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z" class=""></path></svg> 
                            </span>
                            <!-- <i class="fas fa-robot icon"></i> -->
                            <span class="name name-ia">PREVID.IA</span>
                        </a>
                    </li>
                    <li class="item" v-if="client">
                        <a href="#" class="item p-nav-item" @click.prevent="toggleCalculations">
                            <i :class="['fas', 'icon', showCalculations ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
                            <span class="name">Cálculos</span>
                        </a>
                        <ul v-if="showCalculations" class="submenu">
                            <li class="item">
                                <a href="#" @click.prevent="goTo('cts')" class="item p-nav-item">
                                    <i class="far fa-calendar-alt icon"></i>
                                    <span class="name">Tempo de contribuição</span>
                                    
                                </a>
                            </li>
                            <li class="item">
                                <a href="#" @click.prevent="goTo('qualidade')" class="item p-nav-item">
                                    <i class="fas fa-user-check icon"></i>
                                    <span class="name">Qualidade de segurado</span>
                                </a>
                            </li>
                            <li class="item">
                                <a href="#" @click.prevent="goTo('rmi')" class="item p-nav-item">
                                    <i class="fas fa-calculator icon"></i>
                                    <span class="name">Cálculo da RMI</span>
                                </a>
                            </li>
                            <li class="item">
                                <a href="#" @click.prevent="goTo('planejamento')" class="item p-nav-item">
                                    <i class="fas fa-road icon"></i>
                                    <span class="name">Planejamento</span>
                                </a>
                            </li>
                            <li class="item">
                                <a href="#" @click.prevent="goTo('evolucao')" class="item p-nav-item">
                                    <i class="fas fa-dollar-sign icon"></i>
                                    <span class="name">Evolução da Renda</span>
                                </a>
                            </li>
                            <li class="item">
                                <a href="#" @click.prevent="goTo('inicial')" class="item p-nav-item">
                                    <i class="fas fa-hand-holding-usd icon"></i>
                                    <span class="name">Valor da Causa</span>
                                </a>
                            </li>
                            <li class="item">
                                <a href="#" @click.prevent="goTo('liquidacao')" class="item p-nav-item">
                                    <i class="fas fa-file-invoice-dollar icon"></i>
                                    <span class="name">Liquidação de Sentença</span>
                                </a>
                            </li>

                            <li class="item">
                                <a href="#" @click.prevent="goTo('rmc')" class="item p-nav-item">
                                    <i class="fas fa-credit-card icon"></i>
                                    <span class="name">RMC/RCC</span>
                                </a>
                            </li>

                            <li class="item">
                                <a href="#" @click.prevent="goTo('revisao')" class="item p-nav-item">
                                    <i class="fas fa-clipboard-check icon"></i>
                                    <span class="name">Revisão</span>
                                    <!-- <i class="p-icon rouded ml-auto">
                                        <svg class="icon secondary-fill"><use xlink:href="#sprite-right_rounded"/></svg>
                                    </i> -->
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <hr class="separator">
            </nav>
        </aside>
        <div class="backdrop"></div>
        <h5 class="copy d-none d-md-block"> Desenvolvido por <a target="_blank" href="https://www.previd.com.br" class="previd">Previd ®</a></h5>
        </div>
    </div>
 </template>
 <style scoped>
/* ...existing styles... */
.submenu {
    padding-left: 20px; /* Desloca o submenu para a direita */
}
</style>


// WEBPACK FOOTER //
// src/js/components/sidebar.vue